'use strict';

var Marionette = require('backbone.marionette');
var Radio = require('backbone.radio');

var settings = require('../../../utilities/settings').default;
var IndicatorView = require('../step-indicator').default;

export default Marionette.View.extend({

  tagName: 'header',
  attributes: {
    id: 'header',
    class: 'l-header',
    role: 'banner',
  },

  template: require('../templates/client-header.hbs'),
  regions: {
    indicator: '.l-header-indicator',
  },
  ui: {
    title: '.vendor-title',
  },

  initialize: function () {
    Radio.channel('steps').on('change:enabled', this.toggleIndicator, this);
  },

  serializeData: function () {
    return {
      title: window.SETTINGS.vendor_name,
      logo: window.SETTINGS.vendor_logo,
      homepage: window.SETTINGS.vendor_homepage,
    };
  },

  onRender: function () {
    this.toggleIndicator();
    if (settings.inIFrame()) {
      this.ui.title.remove();
    }
  },

  toggleIndicator: function () {
    if (Radio.channel('steps').request('enabled')
        && !Radio.channel('reschedule').request('here')) {
      this.enableIndicator();
    } else {
      this.disableIndicator();
    }
  },

  enableIndicator: function () {
    this.showChildView('indicator', new IndicatorView());
  },

  disableIndicator: function () {
    this.getRegion('indicator').empty();
  },

});
